<template>
<div class="row plain-element">
    <div v-if="!isLoggedIn()"  class="dashboard-cards">
        <NoPermissionComponent/>
    </div>
   <div v-if="getUsername() && getDivisionPlanData()" class="dashboard">
    <div class="row row-cards">
      <div class="row text-start row-back">
        <a class="back-link" @click="hasHistory() ? $router.go(-1): $router.push('/')">
          <span class="material-icons chevron-left">chevron_left</span> Back To Division Plan
        </a>
      </div>
    </div>
    <div class="card card-details card-opportunity-select">
      <p class="error"  v-if="getFormError()">
        <span id="formError">{{ getFormError() }}</span>
      </p>
      <p class="error"  v-else>
      </p>
           <AttachRemoveDivisionSitePlanComponent
              :id = id
              :name = getDivisionPlanData().name
              :company = getDivisionPlanData().company
              :sitePlansArray = getDivisionPlanData().division_site_plan_relation_list
           />
      </div>

    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import { hasHistory } from "@/common/general.js";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue"
import AttachRemoveDivisionSitePlanComponent from "@/components/division_plans/AttachRemoveDivisionSitePlanComponent.vue";

export default {
  name: "AttachRemoveDivisionSitePlan",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    NoPermissionComponent,
    AttachRemoveDivisionSitePlanComponent,
  },
  data() {
    return {

    }
  },
  methods: {
    ...mapGetters(["getDivisionPlanData", "getUsername", "isLoggedIn","getFormError"]),
    ...mapActions(["fetchDivisionPlanData", "performSetFormError"]),
    hasHistory: hasHistory,
    getDivisionPlanDetails(id) {
      this.fetchDivisionPlanData({"id": id })
    },


  },
  computed: {

  },
  created() {
    this.getDivisionPlanDetails(this.id);
    this.performSetFormError(null);
    document.title = "Attach/Remove Site Plans";
    window.scrollTo(0,0);
  },
  beforeRouteUpdate (to, from, next) {
    this.chosenId = to.params.id;
    this.getDivisionPlanDetails(this.chosenId);
    next();
  }

}
</script>
